import moment from "moment";
import React, { useEffect, useState } from "react";
import H1 from "../H1";
import H2 from "../H2";
import { msToString, stringToMS } from "../helpers/time";

export default function TimeCountup({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const [t, setT] = useState();

	useEffect(() => {
    let intervalId;

    // Clear the interval when cue changes or on cleanup
    clearInterval(intervalId);

    if (cue.state === "running") {
        intervalId = setInterval(() => {
            const now = moment().format("x");
            setT(now - cue.startedAt);
        }, 100);

    } else if (cue.state === "reset") {
        setT(stringToMS(cue.startOffset) || 0);
    }

    // Cleanup interval on unmount or when dependencies change
    return () => clearInterval(intervalId);
}, [cue.state, cue.startedAt, cue.startOffset]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<>
			{cue.pre && (
				<H2
					cue={cue}
					text={cue.pre}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
				/>
			)}
			<H1
				cue={cue}
				text={moment
					.duration(t, "milliseconds")
					.format(cue.format || "HH:mm:ss", { trim: cue.trim })}
				baseTheme={baseTheme}
				baseThemeId={baseThemeId}
				tabular={true}
			/>
		</>
	);
}
